import { RouterConstant } from "../routers/index";

/**
 * Determines the required route for an authenticated user based on their completion state.
 * This is the single source of truth for the application's sequential navigation ladder.
 * 
 * Ladder Order:
 * 1. Admin Bypass -> Dashboard
 * 2. Profile Incomplete -> User Profile
 * 3. Access Not Granted -> Choose Packages
 * 4. Not Onboarded -> V2 Onboarding
 * 5. Default -> User Main Dashboard
 */
export const getRequiredRoute = (state: any, options?: { forceProfile?: boolean }): string => {
  const { ROUTERS_PATH } = RouterConstant;

  // 1. Admin Bypass - Only if user explicitly entered through the admin flow
  if (state.isAdmin() && state.isAdminFlow) {
    return ROUTERS_PATH.DASHBOARD;
  }

  // 1.5. Teacher Check -> Teacher Dashboard
  if (state.isTeacher()) {
    return ROUTERS_PATH.TEACHER_DASHBOARD;
  }

  // 2. Profile Incomplete check - Mandatory before entering the app
  if (!state.isProfileComplete()) {
    return ROUTERS_PATH.USERPROFILE;
  }

  // 3. Force Access / Subscription check
  if (!state.isAccessGranted()) {
    return ROUTERS_PATH.CHOOSEPACKAGES;
  }

  // 4. Force Onboarding
  if (!state.isOnboarded()) {
    return ROUTERS_PATH.V2_ONBOARDING;
  }

  // 5. Default landing page for students
  return ROUTERS_PATH.USER_MAIN_DASHBOARD;
};
